import { intlGet } from '@/locales';
// type
import type { CommonOptionsType } from '@/definition/common/data.d';
import { JumpSource } from '@/pages/mailTemplate/data.d';
import type { PeculiarSetupType } from '../typing/list';
import { ActivityStatus, CycleSendState } from '../typing/list';
// utils
// router
import RouterPath from '@/router/routingPath';
// type
import { ExpStageEnum } from '@/pages/activityAbTest/utils/enum/list';
import { DuplicateRemovalRadioEnum } from '@/pages/activityCycle/utils/typing/create';

/** 任务状态  */
export const taskStatusOptions: CommonOptionsType[] = [
  {
    label: '未发布、草稿',
    labelKey: 'ACTIVITY.MANAGE.LIST.UNPUBLISHED',
    value: ActivityStatus.unpublished,
    theme: 'success',
  },
  // { label: '未开始', labelKey: 'ACTIVITY.MANAGE.LIST.NOT.STARTED', value: ActivityStatus.notStarted, theme: 'label' },
  {
    label: '暂停中',
    labelKey: 'ACTIVITY.MANAGE.LIST.SUSPENDED',
    value: ActivityStatus.suspended,
    theme: 'danger',
  },
  {
    label: '发送中断',
    labelKey: 'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER',
    value: ActivityStatus.sending_interrupted,
    theme: 'danger',
  },
  {
    label: '审批中',
    labelKey: 'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL',
    value: ActivityStatus.under_approval,
    theme: 'success',
  },
  {
    label: '已计划',
    labelKey: 'ACTIVITY.MANAGE.LIST.SCHEDULED',
    value: ActivityStatus.scheduled,
    theme: 'success',
  },
  {
    label: '测试进行中',
    labelKey: 'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS',
    value: ActivityStatus.test_in_progress,
    theme: 'primary',
  },
  {
    label: '未通过',
    labelKey: 'ACTIVITY.MANAGE.LIST.FAILED',
    value: ActivityStatus.failed,
    theme: 'danger',
  },
  {
    label: '进行中',
    labelKey: 'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND',
    value: ActivityStatus.processing,
    theme: 'primary',
  },
  {
    label: '已完成',
    labelKey: 'ACTIVITY.MANAGE.LIST.TERMINATED',
    value: ActivityStatus.over,
    theme: 'default',
  },
];
/** 周期状态  */
export const cycleSendStateOptions: CommonOptionsType[] = [
  {
    label: '未开始',
    labelKey: 'ACTIVITY.MANAGE.LIST.NOT.STARTED',
    value: CycleSendState.notStarted,
  },
  {
    label: '未发送',
    labelKey: 'ACTIVITY.MANAGE.LIST.UNSENT',
    value: CycleSendState.unsent,
  },
  {
    label: '发送中',
    labelKey: 'ACTIVITY.MANAGE.LIST.BEING.SENT',
    value: CycleSendState.beingSent,
  },
  {
    label: '已发送',
    labelKey: 'ACTIVITY.MANAGE.LIST.SENT',
    value: CycleSendState.sent,
  },
];

/** 活动状态说明 */
export const activityStateDescOptions = [
  {
    name: '草稿',
    labelKey: 'ACTIVITY.MANAGE.LIST.UNPUBLISHED',
    contentKey: ['ACTIVITY.MANAGE.LIST.UNPUBLISHED.NOTES'],
  },
  {
    name: '审批中',
    labelKey: 'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL',
    contentKey: ['ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.NOTES'],
  },
  {
    name: '已计划',
    labelKey: 'ACTIVITY.MANAGE.LIST.SCHEDULED',
    contentKey: ['ACTIVITY.MANAGE.LIST.SCHEDULED.NOTES'],
  },
  {
    name: '进行中',
    labelKey: 'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND',
    contentKey: ['ACTIVITY.MANAGE.LIST.HAVE.IN.HAND.NOTES'],
  },
  {
    name: '排队中',
    labelKey: 'ACTIVITY.MANAGE.LIST.WAITLIST',
    contentKey: ['ACTIVITY.MANAGE.LIST.WAITLIST.NOTES'],
  },
  {
    name: '发送中断',
    labelKey: 'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER',
    contentKey: ['ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER.NOTES'],
  },
  {
    name: '暂停中',
    labelKey: 'ACTIVITY.MANAGE.LIST.SUSPENDED',
    contentKey: ['ACTIVITY.MANAGE.LIST.SUSPENDED.NOTES'],
  },
  {
    name: '已完成',
    labelKey: 'ACTIVITY.MANAGE.LIST.TERMINATED',
    contentKey: ['ACTIVITY.MANAGE.LIST.TERMINATED.NOTES'],
  },
  {
    name: '已终止',
    labelKey: 'COMMON.TERMINATION.STATE',
    contentKey: ['ACTIVITY.MANAGE.LIST.TERMINATION.NOTES'],
  },
];

/** 状态重置 
 *  - 0 待执行
    - 1 进行中
    - 2 已结束
    - 3 未发布
    - 4 定时任务task_receiver处理中
    - 5 暂停挂起
    - 6 子任务入队完成
    - 7 任务异常
    - 8 审核中
    - 9 驳回
 * 
*/
export const getActivityState = (state: number, item?: any) => {
  let newState = state;
  switch (state) {
    // 进行中 (0: 代表活动处于已计划阶段)
    case 0:
      newState = 10;
      break;
    case 1: // 活动真正处于进行中
    case 4: // 活动真正处于进行中
    case 7: // 用于试验的活动结束后的等待期间 （仅abTest活动会存在此状态）
      newState = 2;
      break;
    // 已结束
    case 2:
      newState = 3;
      break;
    // 未发布
    case 3:
      newState = 1;
      break;
    // 审核中
    case 8:
      newState = 7;
      break;
    // 驳回/未通过
    case 9:
      newState = 8;
      break;
    case 5: // 暂停中
    case 12: // 发送中断(占位符确实导致活动异常)
      newState = 5; // 暂停中
      break;
    default:
      break;
  }
  // AB测试活动展示“测试中”状态（活动处于测试阶段，并且活动状态为进行中）
  if (
    item?.expStage === ExpStageEnum.TEST_IN_PROGRESS &&
    [2].includes(newState)
  ) {
    newState = 11;
  }
  return newState;
};

// 弹层文案
export const defaultPeculiarSetup: PeculiarSetupType = {
  jumpSource: JumpSource.activityList,
  stateDesc: activityStateDescOptions,
  cardTitleKey: 'ACTIVITY.MANAGE.LIST.TITLE',
  searchTagPlaceholderKey: 'ACTIVITY.MANAGE.LIST.SEARCH.TASK.NAME',
  detailsTextKey: 'ACTIVITY.MANAGE.LIST.ACTIVITY.DETAILS',
  delDialogHeaderKey: 'ACTIVITY.MANAGE.LIST.DELETE.HEADER',
  delDialogBodyKey: 'ACTIVITY.MANAGE.LIST.DELETE.CONTENT',
  batchDelDialogHeaderKey: 'ACTIVITY.MANAGE.LIST.BATCH.DELETE.HEADER',
  batchDelDialogBodyKey: 'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONTENT',
  copyPagePath: RouterPath.ACTIVITY_MANAGE_CREATE,
  editPagePath: RouterPath.ACTIVITY_MANAGE_CREATE,
  detailsPagePath: RouterPath.ACTIVITY_MANAGE_DETAILS,
  approvalDetailsPagePath: RouterPath.ACTIVITY_APPROVAL_DETAILS,
};

// 获取周期-去重-组合文本展示
export const getDeduplicatedText = (data: {
  // 是否去重
  periodResetMethod?: number;
  // 去重规则
  isRemovePermanent?: DuplicateRemovalRadioEnum;
  // 去重 - 输入的天数
  periodResetDay?: number;
}) => {
  let text = intlGet('ACTIVITY.MANAGE.CREATE.NO.WEIGHT.LOSS');
  const { periodResetMethod, isRemovePermanent, periodResetDay = 0 } = data;
  if (periodResetMethod === 1) {
    if (isRemovePermanent === DuplicateRemovalRadioEnum.day) {
      text = intlGet('ACTIVITY.MANAGE.LIST.WEIGHT.IN.DAYS', {
        num: periodResetDay,
      });
    } else {
      // 兼容旧数据isRemovePermanent值非1情况显示为: "活动内所有周期去重"
      text = intlGet('ACTIVITY.MANAGE.LIST.ALL.WEIGHT.REMOVAL');
    }
  }
  return text;
};
